export const getWebApplicationVersion = () => process.env.REACT_APP_VERSION;